// Central business + content data for Paliwal Medicos

export const BUSINESS = {
  name: "PALIWAL MEDICOS",
  tagline: "Trusted Healthcare Partner",
  phoneDisplay: "9950206933",
  phoneDial: "+919950206933",
  whatsapp: "919950206933",
  whatsappMsg: "Hello Paliwal Medicos, I would like to order medicines.",
  addressLines: ["Shop No. 48", "M.D.M. Road", "Shastri Nagar", "Jodhpur, Rajasthan"],
  addressShort: "Shop No. 48, M.D.M. Road, Shastri Nagar, Jodhpur",
  hours: "10:00 AM – 11:00 PM",
  hoursNote: "Open Daily · Mon – Sun",
  mapsQuery: "Paliwal Medicos, M.D.M. Road, Shastri Nagar, Jodhpur, Rajasthan",
};

export const telHref = `tel:${BUSINESS.phoneDial}`;
export const whatsappHref = `https://wa.me/${BUSINESS.whatsapp}?text=${encodeURIComponent(BUSINESS.whatsappMsg)}`;
export const directionsHref = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(BUSINESS.mapsQuery)}`;
export const mapsEmbedSrc = `https://www.google.com/maps?q=${encodeURIComponent(BUSINESS.mapsQuery)}&output=embed`;
export const mapsViewHref = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(BUSINESS.mapsQuery)}`;

export const HIGHLIGHTS = [
  "Genuine Medicines",
  "Prescription Medicines",
  "OTC Medicines",
  "Health & Wellness",
  "Baby Care",
  "Personal Care",
  "Fast & Friendly Service",
];

export const CATEGORIES = [
  {
    slug: "prescription",
    title: "Prescription Medicines",
    desc: "Authentic, doctor-prescribed medicines dispensed with care and verification.",
    icon: "FileText",
    tags: ["rx", "doctor", "prescription", "medicine"],
  },
  {
    slug: "otc",
    title: "OTC Medicines",
    desc: "Everyday over-the-counter relief for fever, cold, cough, acidity and pain.",
    icon: "Pill",
    tags: ["otc", "fever", "cold", "pain", "cough"],
  },
  {
    slug: "vitamins",
    title: "Vitamins & Supplements",
    desc: "Multivitamins, minerals and nutritional supplements for daily wellbeing.",
    icon: "Leaf",
    tags: ["vitamin", "supplement", "protein", "immunity"],
  },
  {
    slug: "diabetes",
    title: "Diabetes Care",
    desc: "Glucometers, strips, insulin storage and sugar-management essentials.",
    icon: "Droplet",
    tags: ["diabetes", "sugar", "insulin", "glucometer"],
  },
  {
    slug: "personal-care",
    title: "Personal Care",
    desc: "Skin, hair, oral and hygiene products from brands you trust.",
    icon: "Sparkles",
    tags: ["personal", "skin", "hair", "hygiene", "soap"],
  },
  {
    slug: "baby-care",
    title: "Baby Care",
    desc: "Gentle baby food, diapers, lotions and paediatric essentials.",
    icon: "Baby",
    tags: ["baby", "infant", "diaper", "child"],
  },
  {
    slug: "devices",
    title: "Healthcare Devices",
    desc: "BP monitors, thermometers, nebulizers, oximeters and more.",
    icon: "Stethoscope",
    tags: ["device", "bp", "thermometer", "oximeter", "nebulizer"],
  },
  {
    slug: "first-aid",
    title: "First Aid Products",
    desc: "Bandages, antiseptics, cotton, tapes and complete first-aid kits.",
    icon: "HeartPulse",
    tags: ["first aid", "bandage", "antiseptic", "wound"],
  },
  {
    slug: "ayurvedic",
    title: "Ayurvedic Medicines",
    desc: "Trusted Ayurvedic and herbal formulations for holistic care.",
    icon: "Flower2",
    tags: ["ayurvedic", "herbal", "natural", "immunity"],
  },
];

export const TESTIMONIALS = [
  {
    name: "Rakesh Sharma",
    role: "Shastri Nagar, Jodhpur",
    quote:
      "Always find genuine medicines here. The staff is helpful and remembers my father's regular prescriptions. Truly a trustworthy pharmacy.",
    rating: 5,
  },
  {
    name: "Neha Vyas",
    role: "Regular Customer",
    quote:
      "Uploaded my prescription on WhatsApp and my order was ready in minutes. Fast, friendly and fairly priced — highly recommended.",
    rating: 5,
  },
  {
    name: "Dr. Mahesh Rathore",
    role: "Local Physician",
    quote:
      "I confidently refer my patients to Paliwal Medicos. They stock authentic brands and never compromise on quality.",
    rating: 5,
  },
  {
    name: "Sunita Agarwal",
    role: "Homemaker",
    quote:
      "Open late every day, which is a lifesaver during emergencies. The baby care range is excellent and always in stock.",
    rating: 5,
  },
];

export const FAQS = [
  {
    q: "Do you sell prescription medicines?",
    a: "Yes. We dispense genuine prescription medicines against a valid doctor's prescription. You can upload your prescription online or bring it to the store.",
  },
  {
    q: "What are your business hours?",
    a: "We are open every day of the week, Monday to Sunday, from 10:00 AM to 11:00 PM.",
  },
  {
    q: "How can I order medicines?",
    a: "You can call us at 9950206933, send us your order on WhatsApp, upload a prescription through our website, or simply visit the store.",
  },
  {
    q: "Can I upload my prescription online?",
    a: "Absolutely. Use the secure prescription upload section on this website to send us an image or PDF of your prescription before ordering.",
  },
  {
    q: "Do you provide home delivery?",
    a: "Yes, we offer quick local delivery around Shastri Nagar and nearby areas. Share your order on WhatsApp or call us to confirm delivery availability.",
  },
  {
    q: "How do I contact Paliwal Medicos?",
    a: "Call or WhatsApp us at 9950206933, use the contact form on this page, or visit us at Shop No. 48, M.D.M. Road, Shastri Nagar, Jodhpur.",
  },
];
